import React from 'react'
import { Navigate } from 'react-router-dom'
import { useGlobalState } from 'contexts/GlobalStateContext'

interface SubscriptionFeatureRouteProps {
  children: React.ReactNode
  requiredFeatures?: string[]
}

/**
 * Wrapper component that checks if the user's subscription includes required features.
 * If features are not available, redirects to /dashboard.
 */
const SubscriptionFeatureRoute: React.FC<SubscriptionFeatureRouteProps> = ({ children, requiredFeatures }) => {
  const { checkSubscriptionTierFeature, isLoadingSubscriptionStatus, isSubscriptionStatusLoaded } = useGlobalState()

  // If no features required, allow access
  if (!requiredFeatures || requiredFeatures.length === 0) {
    return <>{children}</>
  }

  // Wait for subscription status to fully load before checking
  // This prevents premature redirects when data hasn't arrived yet
  if (isLoadingSubscriptionStatus || !isSubscriptionStatusLoaded) {
    return null
  }

  // Check if user has ALL required features
  const hasAllFeatures = requiredFeatures.every((feature) => checkSubscriptionTierFeature(feature))

  if (!hasAllFeatures) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}

export default SubscriptionFeatureRoute
